export default __webpack_public_path__ + "static/media/pic6.9388af6c.jpg";